package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.ByteArray
import kotlin.Long
import kotlin.String

public class FileBlobQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun selectById(id: String): Query<ByteArray> = SelectByIdQuery(id) { cursor ->
    cursor.getBytes(0)!!
  }

  public fun put(
    id: String,
    bytes: ByteArray,
    kept_at: Long,
  ) {
    driver.execute(73_602_588,
        """INSERT OR REPLACE INTO file_blob(id, bytes, kept_at) VALUES (?, ?, ?)""", 3) {
          bindString(0, id)
          bindBytes(1, bytes)
          bindLong(2, kept_at)
        }
    notifyQueries(73_602_588) { emit ->
      emit("file_blob")
    }
  }

  public fun remove(id: String) {
    driver.execute(-1_991_205_289, """DELETE FROM file_blob WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_991_205_289) { emit ->
      emit("file_blob")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("file_blob", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("file_blob", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_955_375_937, """SELECT bytes FROM file_blob WHERE id = ?""", mapper,
        1) {
      bindString(0, id)
    }

    override fun toString(): String = "FileBlob.sq:selectById"
  }
}
